import { QuestionMarkCircleIcon as HeroQuestionMarkCircleIcon } from '@heroicons/react/24/outline';
export const QuestionMarkCircleIcon = HeroQuestionMarkCircleIcon;
